import React from 'react';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballContact = () => {
  const { tenant, siteSettings } = useTenant();

  const contactInfo = siteSettings?.contact || {
    name: tenant?.name || 'Throwball Federation of India',
    address: 'House No. 336, Village Khera Khurd, Delhi - 110082, India',
    phone: '+91 99999 69966',
    email: 'nareshmannthrowballindia@gmail.com',
    mapUrl: 'https://www.google.com/maps?q=Khera+Khurd,+Delhi+110082&output=embed',
    social: {
      facebook: 'https://www.facebook.com/throwballIndia',
      instagram: ''
    }
  };

  return (
    <section className="tb-page-section tb-contact-page-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.contact || '/theme/assets/images/banner-3.jpg'} alt="Contact Us Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">Contact Us</h1>
            <span className="tb-mini-line"></span>
          </div>

          <div className="tb-contact-container">
            <div className="tb-contact-row">
              <div className="tb-contact-col">
                <div className="tb-contact-card">
                  <h3 className="tb-contact-title">{contactInfo.name}</h3>

                  <div className="tb-contact-item">
                    <i className="ri-map-pin-line"></i>
                    <div dangerouslySetInnerHTML={{ __html: contactInfo.address.replace(/,/g, '<br />') }} />
                  </div>

                  <div className="tb-contact-item">
                    <i className="ri-phone-line"></i>
                    <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="tb-contact-link">
                      {contactInfo.phone}
                    </a>
                  </div>

                  <div className="tb-contact-item">
                    <i className="ri-mail-line"></i>
                    <a href={`mailto:${contactInfo.email}`} className="tb-contact-link">
                      {contactInfo.email}
                    </a>
                  </div>

                  <div className="tb-follow-box">
                    <h4 className="tb-follow-txt">Follow us on:</h4>
                    <ul className="tb-social-links">
                      <li>
                        <a href={contactInfo.social?.facebook || '#'} target="_blank" rel="noopener noreferrer" className="tb-social-link">
                          <i className="ri-facebook-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href={contactInfo.social?.instagram || '#'} target="_blank" rel="noopener noreferrer" className="tb-social-link">
                          <i className="ri-instagram-line"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="tb-contact-col">
                <div className="tb-contact-map">
                  <iframe
                    src={contactInfo.mapUrl}
                    allowFullScreen
                    loading="lazy"
                    title="Location Map"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThrowballContact;
